/** @jsx jsx */
import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import {
  ButtonProps,
  greyButton,
  primaryAlternativeCss,
  primaryAlternativePaintedCss,
  primaryCss,
  StyledButton,
} from './Button';

const linkStyles = css`
  box-sizing: border-box;
  text-decoration: none;
  line-height: 35px;
`;
const StyledExternalLink = styled(StyledButton.withComponent('a'))`
  ${linkStyles};
`;
const StyledLink = styled(StyledButton.withComponent(Link), { shouldForwardProp: isPropValid })`
  ${linkStyles};
`;

export interface ButtonLinkProps {
  href?: string;
  to?: string;
  isExternal?: boolean;
  target?: string;
}

const ButtonLink = (props: ButtonLinkProps & ButtonProps) => {
  const { isExternal, dataPendo, dataAnalytics, ...rest } = props;
  let LinkComponent;

  if (isExternal) {
    LinkComponent = StyledExternalLink;
  } else {
    LinkComponent = StyledLink;
  }

  return (
    <LinkComponent
      className={props.className}
      data-pendo={dataPendo}
      data-heap={dataAnalytics}
      data-analytics={dataAnalytics}
      {...rest}
    >
      {props.children}
    </LinkComponent>
  );
};

export const PrimaryLink = styled(ButtonLink)`
  ${primaryCss};
`;

export const PrimaryExternalLink = (props: ButtonLinkProps & ButtonProps) => (
  <PrimaryLink isExternal {...props} />
);

export const LargePrimaryButtonLink = styled(PrimaryLink)`
  padding: 0.156rem;
  width: 100%;
  height: 3rem;
  font-weight: normal;
  border-radius: 0.188rem;
`;

export const SmallPrimaryExternalLink = styled(PrimaryExternalLink)`
  font-size: 13px;
  font-weight: 400;
`;

export const PrimaryAlternativePaintedLink = styled(ButtonLink)`
  ${primaryAlternativePaintedCss};
`;

export const PrimaryAlternativePaintedExternalLink = (props: ButtonLinkProps & ButtonProps) => (
  <PrimaryAlternativePaintedLink {...props} isExternal />
);

export const PrimaryAlternativeLink = styled(ButtonLink)`
  ${primaryAlternativeCss};
`;

export const PrimaryAlternativeExternalLink = (props: ButtonLinkProps & ButtonProps) => (
  <PrimaryAlternativeLink {...props} isExternal />
);

export const GreyPrimaryAlternativeLink = styled(ButtonLink)`
  ${greyButton};
`;

export default ButtonLink;
